export interface CsvCourse {
  name: string
  lessons: CsvLesson[]
}

export interface CsvLesson {
  qid: string
  title: string
}

/**
 * curriculum-full.csv 기반 정적 데이터
 * 3개 Course: 메타코어(30), 데이터 리터러시(50), 수감각(30) = 총 110개 레슨
 */
export const CURRICULUM_CSV_DATA: CsvCourse[] = [
  {
    name: '메타코어',
    lessons: [
      { qid: '11504389694563813', title: '[01-02-01] 없어요, 0개 있어요' },
      { qid: '12778050250482753', title: '[02-04-04] 곱하기 99, 백을 이용하자' },
      { qid: '11744150405391536', title: '[02-05-02] 8 × 8, 구구단 절대 외우지 마라' },
      { qid: '12778042826564661', title: '[02-06-08] 안 보이는 것을 보아라, 원과 선을 보면?' },
      { qid: '200189708067995909', title: '[05-08-07] [수열예측(3)] 수열은 예측, Computational Thinking' },
      { qid: '206130220107825412', title: '[05-12-02] [나머지(!!)] 임시나머지, 아직 나누어주지 않은 것' },
      { qid: '1913937076454416', title: '[05-17-09] [Ratio()][평균(2-2)][GRE] 소금물을 섞으면 평균이라고?' },
      { qid: '215613809149149193', title: '[07-03-05] [직to정(4-1)][제곱변화(9)] 정to직으로 보는 18²-15²' },
      { qid: '4762045510616210', title: '[07-04-07] [직to정(A)] 합곱으로 두 수 맞히기, 직to정' },
      { qid: '3633184408372274', title: '[07-12-03] [원주각(2 *!)] 원주각, 깃발 꽂아 같은 방향으로' },
      { qid: '12576575675049440', title: '[03-04-07] 빼지 않는 빼기, 구짝꿍으로' },
      { qid: '5102726896714809', title: '[03-05-06] 만만은 억, 계산 아닌 약속' },
      { qid: '14403460641989964', title: '[03-06-12] 머릿속에서 텔레포트' },
      { qid: '200189708084838661', title: '[04-03-02] [나머지(3)] 도넛 7박스 11개로 나누기' },
      { qid: '18496965072815381', title: '[05-03-02] [new] 이미지로 보는 분수의 나눗셈' },
      { qid: '2029384035763483', title: '[05-14-08] [분수상식(O !!)] 분수 비교, 기울기와 변화로' },
      { qid: '2763577447449654', title: '[06-09-05] [넓이(6-3 !!)][벡터] 좌표평면 위의 평행사변형 넓이' },
      { qid: '215613809132306441', title: '[06-13-02] [로그(2)][만만은억(D)] 백만은 십의 몇번곱? log' },
      { qid: '200189708101353733', title: '[06-16-03] [나머지()] 나머지부터 테일러 시리즈까지' },
      { qid: '2307076849173523', title: '[07-03-02] [직to정(2)] 막대 구부려 직사각형, 제일 큰 것은?' },
      { qid: '14337141942682807', title: '[03-01-08] 6 ÷ 0, 원숭이 사망 사건' },
      { qid: '200189708067602693', title: '[04-09-03] [삼각형(8)][각(5)] 삼각형 세 각의 합 180˚ 증명하기' },
      { qid: '7436463076574232', title: '[05-13-01] [Counting(0)][+ vs x(7)] 경우의 수, 더할까 곱할까' },
      { qid: '19911972524295196', title: '[05-17-10] [new] 소금물 농도 문제, 평균으로 끝내자' },
      { qid: '215613809099145225', title: '[05-19-01] [tf(1)] Sine: 수직 높이 Ratio' },
      { qid: '213674150361890825', title: '[05-19-03] [깨직삼(6 *!)][tf(2)] 45˚ 직각삼각형, 정사각형의 반, 1:1:√2' },
      { qid: '213674150361825289', title: '[05-19-04] [깨직삼(7 *!)][tf(3)] 369직각삼각형, 1:2:√3' },
      { qid: '2479730491953492', title: '[06-03-01] [넓이(A *!)][원()] 단위원의 넓이가 π인 이유' },
      { qid: '6119154638685459', title: '[07-09-08] [2차그래프(7 !!)] 그래프 보고 a, b, c 부호, 즉시 알기' },
      { qid: '4762058647176359', title: '[07-13-01] [tf(7 YT200424 *!)] 어원으로 보는 삼각함수' },
    ],
  },
  {
    name: '데이터 리터러시',
    lessons: [
      { qid: '3076521750201451', title: '[05-17-01] [데이타(1)] 막대그래프와 꺾은선그래프' },
      { qid: '3076532235961453', title: '[05-17-02] [데이타(2)] 원그래프, 비율을 보여주는 차트' },
      { qid: '19911841729119249', title: '[05-17-03] [new] 띠그래프와 그림그래프' },
      { qid: '1748490783851530', title: '[05-17-04] [평균(1)] 평균, 평평하게 균형을 맞춰라' },
      { qid: '5102733540492353', title: '[05-17-05] [평균(YT sam *!)] 3명은 7만 원, 2명은 6만 원, 똑같이 가지려면?' },
      { qid: '1748476556772355', title: '[05-17-06] [데이타()][평균(2)] 데이터를 한마디로' },
      { qid: '1836434861360382', title: '[05-17-07] [Ratio예(속력3)][평균(2-1)] 같은 시간과 다른 속력, 평균 속력은 그냥 평균' },
      { qid: '1864004055106604', title: '[05-17-08] [Ratio예(속력4)] 100 km/h로 갔다가 200 km/h로 돌아오면, 평균 속력은?' },
      { qid: '8356922786456997', title: '[07-05-01] [평균()] 좌표평면에서 내분과 외분' },
      { qid: '8356922148922787', title: '[07-05-02] [평균()] 농도, 내분, 중심 문제? 가중평균으로 간단히!' },
      { qid: '8356924791334313', title: '[07-05-03] [평균()] 평균과 Ratio 문제? 이미지와 의미로 꿰뚫기!' },
      { qid: '8356917426136468', title: '[07-05-04] [평균()] 가중평균, 중복이 많은 값들의 평균' },
      { qid: '8356919162578328', title: '[07-05-05] [평균()][Ratio()] 내분, Ratio 자동확장응용으로' },
      { qid: '8356918013339029', title: '[07-05-06] [평균()] 시소 타는 가중평균과 내분' },
      { qid: '6119221974041949', title: '[07-04-05] [매개변수()][직to정(7)][평균()] 합차로 두 수 맞히기, 평균과 평차' },
      { qid: '4762159327249699', title: '[07-04-06] [직to정(7-1)][평균(3)] 평차를 모르면 꼬마네모로' },
      { qid: '1748491597546507', title: '[07-06-01] [평균(4YT)] 지오평균, 곱하기평균' },
      { qid: '2558975716394332', title: '[07-06-02] [깨직삼(C *!)][Ratio응용()][평균(4-1)][넓이(H)] 깨직삼 속의 피타고라스와 지오평균' },
      { qid: '1748492377687052', title: '[07-06-03] [평균(5)] 조화평균, 합곱을 조화롭게' },
      { qid: '7436471909778440', title: '[07-06-04] [평균()] 왜 왕복평균은 조화평균인가?' },
      { qid: '200189708150505733', title: '[07-06-05] [평균(6)] 지오평균은 다시 지오평균' },
      { qid: '7436475642709011', title: '[07-06-06] [평균(7)] 평균들 한눈에' },
      { qid: '7436464360031258', title: '[07-06-07] [평균(9)][직to정(8)] 평균들의 크기비교, 직to정으로' },
      { qid: '1864009574810672', title: '[07-06-08] [평균(B)] 모든 평균들에 들어있는 산술평균' },
      { qid: '10554824602559846', title: '[07-06-09] [(YT 2202825)] 제곱분수식 이미지로' },
      { qid: '12576574668416477', title: '[07-06-99] [YT-230201] [주식초보도 가능한 평균단가 5초만에 구하는 방법! (Feat. #투자기법 )] 물타기는 평균 구하기' },
      { qid: '200189708017795333', title: '[05-13-02] [Counting(1)] 경우의 수, 쪼개고 곱해라' },
      { qid: '216145742375419913', title: '[05-13-03] [Counting(2)] 전원 줄 세우기, 느낌이 좋아' },
      { qid: '7436457229714440', title: '[05-13-04] [Counting(1-1)] 경우의 수, 더하거나 빼거나' },
      { qid: '3633228339512401', title: '[08-01-01] [Counting(3)] 몇 명만 줄 세우기, 느낌 이용하여' },
      { qid: '1899163034879113', title: '[08-01-02] [Counting(D)] 경우의 수, 나누기 이용하여' },
      { qid: '3633230344389715', title: '[08-01-03] [Counting(4)] 흑백 줄 세우기, 느낌 이용하여' },
      { qid: '3633229346145362', title: '[08-01-04] [Counting(5)] 줄을 세울까 말까? 무한리필을 할까 말까?' },
      { qid: '3633214615749705', title: '[08-01-05] [Counting(6)] 뽑기, 줄 세우기, 나눠주기, 관계 맺기' },
      { qid: '3633218952660045', title: '[08-01-06] [Counting(7)] 모든 길은 흑백 줄 세우기로 통한다' },
      { qid: '3633237382431831', title: '[08-01-07] [Counting(8)] 경우의 수, 나눠주기도 흑백 줄 세우기로' },
      { qid: '1837104809149717', title: '[08-01-08] [Counting(9)] 중복 뽑기는 나눠주기, 결국 흑백 줄 세우기' },
      { qid: '1821859587851282', title: '[08-03-03] [확률(1)] 희한하네! 확률이야, 확률은 넓이' },
      { qid: '10554838695421308', title: '[08-03-04] [확률(YT 220915)] 딸 낳을 때까지의 확률은?' },
      { qid: '156022011364401', title: '[08-03-08] [확률(8)] [수능2015 16번] 조건부확률? 넓이로 생각하라!' },
      { qid: '6119226294175076', title: '[08-03-09] [확률(9 YT)] 몬티 홀 문제, 깨봉확률네모로 간단하게!' },
      { qid: '6119189778564406', title: '[08-03-10] [확률(A YT3)] 간수와 사형수 문제, 깨봉확률네모를 떠올려라!' },
      { qid: '6119188880983349', title: '[08-03-11] [확률(B YT)] 문이 100개인 몬티 홀 문제? 역시 깨봉확률네모로!' },
      { qid: '6895000248943784', title: '[08-04-01] [통계(1 YT)] [수능2021나11] 정규분포의 의미' },
      { qid: '6119132501148924', title: '[08-04-02] [통계(2 YT)] 내 위치는 평균에서 표준편차가 몇개?' },
      { qid: '6895007538644153', title: '[08-04-03] [확률(E )] 확률분포의 일차변환, 2X+30' },
      { qid: '6119127400875251', title: '[08-04-04] [통계(3 YT)] 표준편차 구하기? 2차 평균으로!' },
      { qid: '6894996776060064', title: '[08-04-05] [통계(4 YT)] [수능2021나19, 2020가13] 정규분포 확률 문제, 핵심은 표준편차의 개수!' },
      { qid: '7436463756051481', title: '[08-04-06] [확률(F *!*)] 모평균과 표본평균의 차이' },
      { qid: '6119208443217227', title: '[08-04-07] [통계()] 표본으로 전체추정? 널뛰기정도 줄이기!' },
    ],
  },
  {
    name: '수감각',
    lessons: [
      { qid: '12778058186105939', title: '[03-05-01] 8천, 9천, 그다음은?' },
      { qid: '12576576161588706', title: '[03-05-05] 12천, 12개의 천도복숭아' },
      { qid: '13034140116591626', title: '[03-05-12] 만억조경해, 깨봉만만보드' },
      { qid: '200189708151161093', title: '[03-06-06] 백만은 천이 몇 개? 나누기네' },
      { qid: '220696946396889091', title: '[04-05-02] [번곱(2)][만만은억(C)] 만억조, 십의 어깨 위로' },
      { qid: '216145756300509193', title: '[04-07-05] [단위(4)] 마이크로와 나노, 정말 작네' },
      { qid: '3138636901024788', title: '[04-07-06] [단위(8)] 바이트, 미디어 크기의 단위' },
      { qid: '18612415588893877', title: '[05-04-02] [new] 10 %와 1/10은 0.1 아니었어?' },
      { qid: '3633207468655682', title: '[06-13-03] [번곱(6)(YT)][로그] 로그와 코로나' },
      { qid: '2475100700968105', title: '[07-07-04] [진법(4)] 만만은 억, 이진수 버전' },
      { qid: '12778060383921239', title: '[03-04-09] 깨봉십진수, 6, 7, 8, 9가 사라지는 마술' },
      { qid: '200954059153211706', title: '[04-03-04] [나머지()] 3백 ÷ (백 - 2), 나머지는 몫 × 차이' },
      { qid: '2118090537075722', title: '[04-14-05] [분수상식(E)] 통분없이 의미로 즉시 대답하기' },
      { qid: '18158233350211096', title: '[04-14-10] [new] 위 아래의 차이가 같은 두 분수의 뺄셈' },
      { qid: '18399610302530909', title: '[05-02-08] [new][십진수] 음수 연산, 깨봉십진수로' },
      { qid: '18558199906338438', title: '[05-02-09] [new][십진수] 분수에서도 깨봉십진수' },
      { qid: '6119117636535524', title: '[05-12-03] [나머지(2 !!)] 임시몫, 임시나머지, 나머지 가족' },
      { qid: '200189708100632837', title: '[05-12-05] [나머지()] 나머지 빨리 구하기' },
      { qid: '18866106539607061', title: '[05-12-09] [new] 나머지? 나누기 앞뒤를 가지고 놀아라!' },
      { qid: '3633204759135297', title: '[08-02-02] [Counting(C)] 경우의 수, 다양한 재활용' },
      { qid: '18612442549879991', title: '[05-04-05] [new] 20 % 떨어지면, 몇 퍼센트 올라야 해?' },
      { qid: '18607286273869610', title: '[05-04-06] [new] 20 % 오르고 30 % 내리면?' },
      { qid: '219196158843551753', title: '[05-14-03] [Ratio(1)] 기울기, 수직 변화는 수평 변화의 몇배?' },
      { qid: '215613809031774217', title: '[05-14-04] [Ratio(2)] Ratio를 눈에 보이게? 기울기로!' },
      { qid: '19561726270717872', title: '[05-14-06] [YT-25MMDD] [리메이크] [분수 방정식, 통분 없이 3초 만에 푸는 방법! | 통분 없이 계산 없이 1초 만에 답하는 방법! (feat.분수, 소금물)] 분수 이해, 커피 한 스푼으로!' },
      { qid: '224168801330004281', title: '[05-14-07] [Ratio()][분수(O-3 YT220317)] 격자 속 직사각형 넓이도 Ratio로' },
      { qid: '1836428418909437', title: '[05-15-07] [Ratio(2)] Ratio 자동 확장, A : B : (A+B) : (A-B)' },
      { qid: '1778225924572229', title: '[05-16-01] [Ratio응용()][PSLE 2019] 15 % 할인받아 더 많이 샀다? Ratio로 해결!' },
      { qid: '7436460568380433', title: '[05-16-07] [Ratio()] 3개 이상의 Ratio도 자유자재로' },
      { qid: '7436473981764624', title: '[06-07-03] [1차(F *!)][그래프()] 두 직선 그래프의 합은 다시 직선' },
    ],
  },
]
